const form = {
    formItems_1: [
        {
            key: "name",
            label: "渠道名称",
            require: true,
            componentName: "input",
            message: "请填写渠道名称"
        },
        {
            key: "hideTargetIds",
            label: "渠道隐藏指标",
            require: false,
            componentName: "select",
            placeholder: "请选择需要隐藏的指标",
            allowClear: true,
            options: [],
            mode: 'multiple'
        },
        {
            key: "rewardRate",
            label: "分成比例",
            require: false,
            componentName: "input",
            message: "请填写分成比例",
            placeholder: "请填写分成比例,0~100"
        },
        {
            key: "company",
            label: "公司名称",
            require: false,
            componentName: "input",
            message: "请填写公司名称"
        },
        {
            key: "contact",
            label: "联系人",
            require: false,
            componentName: "input",
            message: "请填写联系人"
        },
        {
            key: "mobile",
            label: "手机号",
            require: false,
            componentName: "input",
            message: "请填写手机号"
        },
        {
            key: "address",
            label: "通讯地址",
            require: false,
            componentName: "textarea",
            message: "请填写通讯地址"
        }
    ],
    formItems_2: [
        {
            key: "name",
            label: "渠道名称",
            require: true,
            componentName: "input",
            message: "请填写渠道名称"
        },
        {
            key: "parentId",
            label: "一级渠道",
            require: true,
            componentName: "select",
            message: "请选择一级渠道",
            options: []
        },
        {
            key: "isCooperation",
            label: "合作状态",
            require: true,
            componentName: "radio",
            message: "请选择合作状态",
            options: [
                { label: '合作中', value: 1 },
                { label: '不合作', value: 0 },
            ]
        },
        {
            key: "rewardRate",
            label: "分成比例",
            require: false,
            componentName: "input",
            message: "请填写分成比例",
            placeholder: "请填写分成比例,0~100"
        },
        {
            key: "company",
            label: "公司名称",
            require: false,
            componentName: "input",
            message: "请填写公司名称"
        },
        {
            key: "contact",
            label: "联系人",
            require: false,
            componentName: "input",
            message: "请填写联系人"
        },
        {
            key: "mobile",
            label: "手机号",
            require: false,
            componentName: "input",
            message: "请填写手机号"
        },
        {
            key: "address",
            label: "通讯地址",
            require: false,
            componentName: "textarea",
            message: "请填写通讯地址"
        },
        {
            key: 'newUserDeductRate',
            label: '新增扣量(%)',
            require: false,
            componentName: 'input',
            message: '请填写新增扣量'
        },
        {
            key: 'incomeDeductRate',
            label: '收入扣量(%)',
            require: false,
            componentName: 'input',
            message: '请填写收入扣量'
        }
    ],
    formItems_3: [
        {
            key: "codes",
            label: "渠道号",
            require: true,
            componentName: "input",
            message: "请填写渠道号",
            placeholder: "请填写渠道号,多个用英文逗号隔开",
            disabled: true
        },
        {
            key: "name",
            label: "渠道名称",
            require: true,
            componentName: "input",
            message: "请填写渠道名称"
        },
        {
            key: "firstId",
            label: "一级渠道",
            require: true,
            componentName: "select",
            message: "请选择一级渠道",
            options: []
        },
        {
            key: "parentId",
            label: "二级渠道",
            require: true,
            componentName: "select",
            message: "请选择二级渠道",
            options: []
        },
        {
            key: "isCooperation",
            label: "合作状态",
            require: true,
            componentName: "radio",
            message: "请选择合作状态",
            options: [
                { label: '合作中', value: 1 },
                { label: '不合作', value: 0 },
            ]
        },
        {
            key: "rewardRate",
            label: "分成比例",
            require: false,
            componentName: "input",
            message: "请填写分成比例",
            placeholder: "请填写分成比例,0~100"
        },
        {
            key: "company",
            label: "公司名称",
            require: false,
            componentName: "input",
            message: "请填写公司名称"
        },
        {
            key: "contact",
            label: "联系人",
            require: false,
            componentName: "input",
            message: "请填写联系人"
        },
        {
            key: "mobile",
            label: "手机号",
            require: false,
            componentName: "input",
            message: "请填写手机号"
        },
        {
            key: "address",
            label: "通讯地址",
            require: false,
            componentName: "textarea",
            message: "请填写通讯地址"
        },
        {
            key: 'newUserDeductRate',
            label: '新增扣量(%)',
            require: false,
            componentName: 'input',
            message: '请填写新增扣量'
        },
        {
            key: 'incomeDeductRate',
            label: '收入扣量(%)',
            require: false,
            componentName: 'input',
            message: '请填写收入扣量'
        },
        {
            key: 'createUserDeductRate',
            label: '首次创角扣量(%)',
            require: false,
            componentName: 'input',
            message: '请填写首次创角扣量'
        }
    ]
};

export default form;